import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    gridChild: {
      display: "flex",
      flexDirection: "column",
    },
    avatar: {
      width: "49px",
      height: "48px",
      backgroundColor: theme.gray100,
      border: "1px solid rgba(229, 226, 241, 0.1)",
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "19px",
      color: theme.gray800,
    },
    detailsCard: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8),
      marginBottom: theme.spacing(12),
    },
    detailsPaper: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
    },
    mainDataContainer: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(6, 8),
      gap: theme.spacing(8),
      boxShadow: `0px 1px 0px ${theme.gray100}`,
    },
    dataContainer: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8),
      gap: theme.spacing(8),
    },
    smallText: {
      color: theme.gray500,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    largeText: {
      color: theme.gray800,
      fontSize: "16px",
      lineHeight: "24px",
      textOverflow: "ellipsis",
      overflow: "hidden",
    },
    detailsItem: {
      "& + &": { marginTop: theme.spacing(8) },
    },
    sectionHeader: {
      color: theme.gray800,
      fontSize: 18,
      lineHeight: theme.spacing(11),
      marginBottom: theme.spacing(5),
    },
    modalButton: {
      height: theme.spacing(24),
      marginTop: theme.spacing(12),
    },
    modalInput: {
      maxWidth: "100%",
      width: 406,
      "& + &": { marginTop: theme.spacing(10) },
    },
    badgeBackground: {
      backgroundColor: theme.primary500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    bottomSpace: {
      marginBottom: theme.spacing(12),
    },
    container: {
      marginTop: theme.spacing(6),
    },
    overflowText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  }),
);
